export const VENUE_QUERY = /* GraphQL */ `
  query Venue($id: ID!) {
    venue(id: $id) {
      id
      placeId
      name
      formattedAddress
      types
      priceLevel
      rating
      userRatingCount
      description
      website
      phone
      googleMapsUrl
      reservable
      photoUrl
      photoAttributions
      qualityTier
      qualityScore
      qualityRationale
      weekdayHours
    }
  }
`;

/** Selection set for embedding inside the recommendations query. */
export const VENUE_RECOMMENDATION_FRAGMENT = /* GraphQL */ `
  venue {
    id
    placeId
    name
    formattedAddress
    rating
    userRatingCount
    priceLevel
    description
    photoUrl
    photoAttributions
    googleMapsUrl
    website
    qualityTier
    weekdayHours
  }
`;

// ─── Mobile suggest / decision ───────────────────────────────────────

export const SUGGEST_VENUE_Q = /* GraphQL */ `
  query SuggestVenue {
    suggestVenue {
      id
      placeId
      name
      formattedAddress
      lat
      lng
      rating
      userRatingCount
      priceLevel
      description
      photoUrl
      photoAttributions
      googleMapsUrl
      website
      qualityTier
      cuisine
      pitch
      weekdayHours
    }
  }
`;

export const RECORD_VENUE_DECISION_M = /* GraphQL */ `
  mutation RecordVenueDecision($venueId: ID!, $decision: String!) {
    recordVenueDecision(venueId: $venueId, decision: $decision)
  }
`;
